/* eslint-disable no-nested-ternary */
import React, { FC, useState } from 'react';
import { styled } from 'linaria/react';
import { CountryButton, CountryWithIcon } from '@entities/country';
import { generateUuid } from '@shared/lib';
import { ToolTipMobileText } from '@shared/ui/atoms';
import { Payee } from '@root/api/ump-catalog-manager';
import { useSelectCountry } from '../model/useSelectCountry';
import { useCountryList } from '../lib/useCountryList';
import { useActiveCountry } from '../lib/useActiveCountry';
interface Props {
  isSteam: boolean;
  showVouchersForm: boolean;
  activeService?: Payee;
  countryVouchers: CountryWithIcon[];
}
const CountryList: FC<Props> = ({
  showVouchersForm,
  isSteam,
  activeService,
  countryVouchers
}) => {
  const [isCISCountryListModalActive, setIsCISCountryListModalActive] = useState(false);
  const handleCISCountryListModalSwitch = e => {
    e?.stopPropagation();
    setIsCISCountryListModalActive(prev => !prev);
  };
  const {
    handleCountryClick
  } = useSelectCountry({
    isSteam,
    showVouchersForm
  });
  const {
    countryList
  } = useCountryList({
    isSteam,
    showVouchersForm,
    countryVouchers,
    handleCISCountryListModalSwitch
  });
  const {
    activeCountryItem
  } = useActiveCountry({
    isSteam,
    showVouchersForm
  });
  return <>
      <CountriesWrapper>
        {countryList?.map(country => country && <CountryButton key={generateUuid()} country={country.country} icon={country.icon} activeCountry={activeCountryItem} handleCountryClick={handleCountryClick} tooltip={country.tooltip} activeService={activeService} />)}
      </CountriesWrapper>
      <ToolTipMobileText open={isCISCountryListModalActive} title={activeService?.features?.country_web?.split(', ')[2]} handleClose={handleCISCountryListModalSwitch}>
        Азербайджан, Армения, Беларусь, Казахстан, Киргизия, Молдова, Таджикистан, Туркменистан, Узбекистан
      </ToolTipMobileText>
    </>;
};
export default CountryList;
const CountriesWrapper = /*#__PURE__*/styled('div')({
  name: "CountriesWrapper",
  class: "cz5p0m8",
  propsAsIs: false
});

require("./CountryList.linaria.module.css!=!../../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./CountryList.tsx");